import { render, staticRenderFns } from "./volunteer.vue?vue&type=template&id=5a517e6b&scoped=true&"
import script from "./volunteer.vue?vue&type=script&lang=js&"
export * from "./volunteer.vue?vue&type=script&lang=js&"
import style0 from "./volunteer.vue?vue&type=style&index=0&id=5a517e6b&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a517e6b",
  null
  
)

export default component.exports